// extracted by mini-css-extract-plugin
module.exports = {"card":"_5D-SeQ-v","modal":"_5DDEKEWv"};